<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="6" lg="5">
          <span>PAGOS: SOLICITUDES INSCRIPCIONES</span>
        </v-col>

        <v-col cols="12" md="6" lg="5">
          <v-pagination
            class="custom-pagination"
            v-model="pagina"
            :length="metadatos?.totalPaginas || 0"
            :total-visible="10"
            @input="listar"></v-pagination>
        </v-col>

        <v-col cols="12" md="6" lg="2">
          <v-select
            :items="[10, 25, 50, 75, 100]"
            label="Items por página"
            v-model="itemsPorPagina"
            outlined
            dense
            hide-details
            :disabled="items.length == 0"
            @change="cambiarPagina" />
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-row dense>
      <v-col v-if="this.$store.state.CARGO.id == 1" cols="12" :md="3" :lg="2">
        <div class="d-flex">
          <v-switch style="margin-top: -4px" v-model="mostrarTodasSedes" hide-details label="Ver todos"></v-switch>
        </div>
      </v-col>

      <v-col cols="12" md="3" lg="2">
        <vue-select
          v-model="sedeEspecificaId"
          class="style-chooser"
          placeholder="Seleccione una sede"
          :options="sedes"
          label="nombre"
          :reduce="(option) => option.id"
          @input="listarRestableciendoPagina">
        </vue-select>
      </v-col>

      <v-col cols="12" :md="this.$store.state.CARGO.id == 1 ? 3 : 6" :lg="this.$store.state.CARGO.id == 1 ? 6 : 8">
        <v-btn
          class="mx-1"
          title="Ver y Aprobar"
          small
          :disabled="item == null"
          @click="$refs.modalMostrarSolicitudInscripcionRef.abrir(item)">
          <v-icon>mdi-eye</v-icon>

          Ver y Aprobar
        </v-btn>

        <v-btn class="mx-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" lg="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="buscar"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoSolicitudesInscripcionesPaginados
          ref="listadoRef"
          :items="items"
          :cargando="cargando"
          @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalMostrarSolicitudInscripcion
      ref="modalMostrarSolicitudInscripcionRef"
      :visibleBotonAprobar="true"
      @cerrar="listar" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoSolicitudesInscripcionesPaginados from '../components/ListadoSolicitudesInscripcionesPaginados.vue';
import SolicitudInscripcionService from '../services/solicitud-inscripcion.service';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import SedeService from '../services/sede.service';
import 'vue-select/dist/vue-select.css';
import ModalMostrarSolicitudInscripcion from '../components/ModalMostrarSolicitudInscripcion.vue';

export default {
  name: 'SolicitudesInscripcionesLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoSolicitudesInscripcionesPaginados,
    ModalMostrarSolicitudInscripcion,
  },
  data() {
    return {
      nombreItem: 'Solicitud Inscripción',
      sedeEspecificaId: null,
      sedes: [],
      mostrarTodasSedes: false,
    };
  },
  mounted() {
    this.listar();
    this.obtenerSedes();
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      this.sedeEspecificaId = null;
      this.obtenerSedes();

      if (!this.mostrarTodasSedes) {
        this.listarRestableciendoPagina();
      }
    },
    mostrarTodasSedes() {
      this.sedeEspecificaId = null;
      this.obtenerSedes();
      this.listarRestableciendoPagina();
    },
  },
  methods: {
    listar() {
      const params = {
        pagina: this.pagina,
        itemsPorPagina: this.itemsPorPagina,
        busqueda: this.busqueda,
        sedeEspecificaId: this.sedeEspecificaId,
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
      };

      this.obtenerDatosPaginadosConNotificacion(
        SolicitudInscripcionService.findAllPaginado,
        'items',
        'metadatos',
        this.nombreItem,
        params,
      );

      this.item = null;
    },
    async obtenerSedes() {
      await this.obtenerDatosMixin(SedeService.findAll, 'sedes', {
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
      });
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>